/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 14:08:39
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-02 17:12:24
 */
import TextButton from './text';
import CopyLinkButton from './copyLink/index';
export default {
	TextButton,
	CopyLinkButton,
};
